// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import router from './router.js'
import Vue from 'vue'
import store from './store/'
import {i18n} from './localization'

import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/bootstrap/dist/js/bootstrap.js'
import '../node_modules/animate.css/animate.min.css'
import '../node_modules/vue2-animate/dist/vue2-animate.min.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.min.css';
import gaAnalytics from "./mixins/gaAnalytics";

import App from './App.vue'
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
	config: {
		id: "G-Z5WVV5H2TH",
		params: {
			send_page_view: true
		}
	},
	enabled: false,
});

Vue.use(gaAnalytics);

Vue.config.productionTip = false

/* eslint-disable no-new */
window.app = new Vue({
	el: '#app',
	router,
	store,
	i18n,
	template: '<App/>',
	components: {
		App
	}
})
